<template>
  <div>
    <TermsFetcher :path="'terms-of-use'" />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import TermsFetcher from "../terms-fetcher.vue";

@Options({
  title: "E4T: Terms of use",
  components: {
    TermsFetcher,
  },
})
export default class extends Vue {}
</script>

<style lang="scss"></style>
